import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row pt-2" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = { id: "guidanceContent" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "text-muted mt-2 mb-0" }
const _hoisted_9 = { class: "row pt-4" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row pt-4" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = {
  key: 0,
  class: "row pt-2"
}
const _hoisted_14 = { class: "col" }

import { ref, watch, computed, onMounted } from "vue";
import OptionsQuestion from "@/guiide/components/common/OptionsQuestion.vue";
import IncomeGuidanceSummary from "./IncomeGuidanceSummary.vue";
import Help from "@/guiide/components/common/Help.vue";
import { Retiree } from "../../ts/retiree";
import { mapBooleanToYesNo, mapYesNoToBoolean } from "@/guiide/ts/utilities";
import Lifestyle from "@/guiide/ts/lifestyle";
import { SuggestedAmounts } from "../../ts/wants/suggestedAmounts";
import IncomeCalculator from "@/guiide/ts/incomeCalculator";
import HelpText from "@/guiide/ts/helpText";
import { IncomeGuidanceAnswers } from "@/guiide/ts/wants/incomeGuidanceAnswers";
import { yesNoOptions, getYesNoWidth } from "../../ts/utilities";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'IncomeGuidance',
  props: {
    showDescription: { type: Boolean, default: false },
    displayContent: { type: Boolean, default: false }
},
  emits: ["incomeGuidanceChanged"],
  setup(__props, { expose: __expose, emit: __emit }) {

__expose({ getAnswers });

const store = useStore();
const calculator = new IncomeCalculator();

const liveInLondonModel = ref("No");
const supportingPartnerModel = ref("No");
const lifestyleModel = ref("Moderate");

const suggestedAmountOnPLSADate = ref(0);
const suggestedAmountAtRetirement = ref(0);

const isExpanded = ref(false);

const emit = __emit;

const props = __props;

onMounted(() => {
    isExpanded.value = props.displayContent;
});

watch(() => store.state.retiree, (newRetiree: Retiree) => {
    if (newRetiree == null) {
        return;
    }

    liveInLondonModel.value = mapBooleanToYesNo(
        newRetiree.requirements.livesInLondon
    );

    supportingPartnerModel.value = mapBooleanToYesNo(
        newRetiree.requirements.isSupportingPartner
    );

    lifestyleModel.value = newRetiree.requirements.targetLifestyle;

    calculateSuggestedAmounts();
});

watch(() => props.displayContent, (newValue: boolean) => {
    if (newValue == isExpanded.value) {
        return;
    }

    isExpanded.value = newValue;
});

const retirementDate = computed<Date | null>(() => {
    if (store.state.retiree == null) {
        return null;
    }
    return new Date(store.state.retiree.retirementDate);
});

function calculateSuggestedAmounts() {
    if (retirementDate.value == null) {
        return;
    }

    const answers = getAnswers();

    suggestedAmountOnPLSADate.value = calculator.getBaseAmount(
        answers.livesInLondon,
        answers.supportingPartner,
        answers.lifestyle);

    suggestedAmountAtRetirement.value = calculator.calcSuggestedRetirementIncome(
        answers.livesInLondon,
        answers.supportingPartner,
        answers.lifestyle,
        retirementDate.value
    );

    const eventInfo: SuggestedAmounts = {
        suggestedAmountOnPLSADate: suggestedAmountOnPLSADate.value,
        suggestedAmountAtRetirement: suggestedAmountAtRetirement.value
    };
    emit('incomeGuidanceChanged', eventInfo);
}

function toggleCollapse() {
    isExpanded.value = !isExpanded.value;
}

function getAnswers(): IncomeGuidanceAnswers {
    const livesInLondon = mapYesNoToBoolean(liveInLondonModel.value);
    const supportingPartner = mapYesNoToBoolean(supportingPartnerModel.value);
    const lifestyle: Lifestyle = Lifestyle[lifestyleModel.value as keyof typeof Lifestyle];
    return { livesInLondon, supportingPartner, lifestyle };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _cache[2] || (_cache[2] = _createTextVNode(" What income do you want to aim for? ")),
          _createElementVNode("button", {
            ref: "collapseButton",
            class: "btn",
            type: "button",
            onClick: toggleCollapse,
            "aria-expanded": isExpanded.value,
            "aria-controls": "guidanceContent",
            "aria-label": "Toggle display of help with starting income"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["arrowhead bi bi-chevron-down ms-auto", { 'rotate-arrow': isExpanded.value }])
            }, null, 2)
          ], 8, _hoisted_4)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _cache[3] || (_cache[3] = _createTextVNode(" Answer the questions below to get a suggested retirement income after tax. ")),
                _createVNode(Help, {
                  title: "After tax income",
                  text: _unref(HelpText).ReqmntAfterTaxIncome()
                }, null, 8, ["text"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(OptionsQuestion, {
                name: "liveInLondon",
                question: "Do you live in Greater London (as it's more expensive there)?",
                options: _unref(yesNoOptions),
                selected: liveInLondonModel.value,
                "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((liveInLondonModel).value = $event)),
                onChanged: calculateSuggestedAmounts,
                width: _unref(getYesNoWidth)()
              }, null, 8, ["options", "selected", "width"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(OptionsQuestion, {
                name: "lifestyle",
                question: "Which type of retirement do you want to aim for?",
                options: ['Minimum', 'Moderate', 'Comfortable'],
                selected: lifestyleModel.value,
                "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => ((lifestyleModel).value = $event)),
                onChanged: calculateSuggestedAmounts,
                width: 75
              }, null, 8, ["selected"])
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row pt-2" }, [
            _createElementVNode("div", { class: "col" }, [
              _createElementVNode("div", {
                class: "alert alert-info",
                role: "alert"
              }, [
                _createElementVNode("p", { class: "mb-0" }, [
                  _createElementVNode("strong", null, "Minimum"),
                  _createTextVNode(" - covers all your needs, with some left over for fun")
                ]),
                _createElementVNode("p", { class: "mb-0" }, [
                  _createElementVNode("strong", null, "Moderate"),
                  _createTextVNode(" - more financial security and flexibility")
                ]),
                _createElementVNode("p", { class: "mb-2" }, [
                  _createElementVNode("strong", null, "Comfortable"),
                  _createTextVNode(" - more financial freedom and some luxuries")
                ]),
                _createElementVNode("p", { class: "mb-0" }, [
                  _createElementVNode("a", {
                    href: "https://www.retirementlivingstandards.org.uk",
                    target: "_blank"
                  }, "Visit the Retirement Living Standards website"),
                  _createTextVNode(" to find out more.")
                ])
              ])
            ])
          ], -1)),
          (__props.showDescription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(IncomeGuidanceSummary, {
                    "income-setup-mode": false,
                    "suggested-amount-on-plsa-date": suggestedAmountOnPLSADate.value,
                    "suggested-amount-at-retirement": suggestedAmountAtRetirement.value
                  }, null, 8, ["suggested-amount-on-plsa-date", "suggested-amount-at-retirement"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, isExpanded.value]
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})